// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QqCircleFilledSvg from "@ant-design/icons-svg/es/asn/QqCircleFilled";
import AntdIcon from '../components/AntdIcon';

var QqCircleFilled = function QqCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: QqCircleFilledSvg
  }));
};

QqCircleFilled.displayName = 'QqCircleFilled';
export default React.forwardRef(QqCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/QqCircleFilled.js
// module id = 1645
// module chunks = 0